import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a71e9aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid p-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "portfolio-bg-overlay" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "preview-banner"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" This is brochure preview. ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "DO NOT SHARE", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" with anyone else. Expires in 1 hour. ")
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  style: {"overflow-x":"hidden","overflow-y":"auto"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"48px","width":"100%"} }, null, -1))
const _hoisted_11 = {
  class: "container main-container",
  style: {"background-color":"rgba(255, 255, 255, 1)"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "anchor",
  id: "home"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "anchor",
  id: "overview"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "anchor",
  id: "location"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "anchor",
  id: "details"
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "anchor",
  id: "facilities"
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "anchor",
  id: "layout"
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "anchor",
  id: "contact"
}, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d-none d-sm-block",
  style: {"height":"48px","width":"100%"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_PortfolioCarousel = _resolveComponent("PortfolioCarousel")!
  const _component_PortfolioOverview = _resolveComponent("PortfolioOverview")!
  const _component_PortfolioMap = _resolveComponent("PortfolioMap")!
  const _component_PortfolioDetails = _resolveComponent("PortfolioDetails")!
  const _component_PortfolioFacilities = _resolveComponent("PortfolioFacilities")!
  const _component_PortfolioLayout = _resolveComponent("PortfolioLayout")!
  const _component_PortfolioCalculate = _resolveComponent("PortfolioCalculate")!
  const _component_PortfolioContactPerson = _resolveComponent("PortfolioContactPerson")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "portfolio-bg",
      style: _normalizeStyle({
        backgroundImage: 'url(' + _ctx.backgroundImage + ')',
      })
    }, _hoisted_3, 4),
    (_ctx.isPreview)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_8))
      : _createCommentVNode("", true),
    (_ctx.portfolio != null)
      ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
          _createVNode(_component_Header, {
            title: _ctx.portfolio.name
          }, null, 8, ["title"]),
          _createElementVNode("button", {
            type: "button",
            class: "btn whatsapp-button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (
          _ctx.openWhatsappLink(
            `Hi ${_ctx.contactName}, I would like to know more about Project ${_ctx.portfolio.name}.`
          )
        ))
          }),
          _hoisted_10,
          _createElementVNode("section", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_PortfolioCarousel, { portfolio: _ctx.portfolio }, null, 8, ["portfolio"]),
            _hoisted_13,
            _createVNode(_component_PortfolioOverview, { portfolio: _ctx.portfolio }, null, 8, ["portfolio"]),
            _hoisted_14,
            _createVNode(_component_PortfolioMap, { portfolio: _ctx.portfolio }, null, 8, ["portfolio"]),
            _hoisted_15,
            _createVNode(_component_PortfolioDetails, { portfolio: _ctx.portfolio }, null, 8, ["portfolio"]),
            _hoisted_16,
            _createVNode(_component_PortfolioFacilities, { portfolio: _ctx.portfolio }, null, 8, ["portfolio"]),
            _hoisted_17,
            _createVNode(_component_PortfolioLayout, {
              portfolio: _ctx.portfolio,
              onOnContactMe: _ctx.openWhatsappLink
            }, null, 8, ["portfolio", "onOnContactMe"]),
            _createVNode(_component_PortfolioCalculate),
            _hoisted_18,
            _createVNode(_component_PortfolioContactPerson, { portfolio: _ctx.portfolio }, null, 8, ["portfolio"])
          ]),
          _hoisted_19,
          _createVNode(_component_Footer)
        ]))
      : _createCommentVNode("", true)
  ]))
}